const getPromotionReviewHashForCategory = (category) => {
  switch (category) {
    case 'vaccinations':
      return 'promotion-vaccinations';
    case 'trainingCertifications':
      return 'promotion-training';
    case 'licensesCertifications':
      return 'promotion-licenses';
    case 'onboardingRequirements':
      return 'promotion-onboarding';
    case 'scholarlyActivity':
      return 'promotion-scholarly';
    case 'vaccinationCard':
      return 'promotion-vaccinations';
    default:
      return 'promotion';
  }
};

export const getNotificationTargetPath = (notification, userRole) => {
  const data = notification?.data || {};
  const type = notification?.type;

  if (!type) return null;

  if (type === 'assignment' && data.source === 'promotionRequirements') {
    return userRole === 'resident'
      ? '/profile?tab=documents'
      : (data.residentId ? `/resident-profile/${data.residentId}` : '/users');
  }

  if (type === 'reminder' && data.source === 'promotionRequirementsRecurrence') {
    return userRole === 'resident'
      ? '/profile?tab=documents'
      : (data.residentId ? `/resident-profile/${data.residentId}` : '/users');
  }

  if (type === 'reminder' && data.source === 'promotionEvidenceSubmission') {
    return `/users#${getPromotionReviewHashForCategory(data.category)}`;
  }

  if (
    (type === 'approval' || type === 'rejection') &&
    data.source === 'promotionEvidenceReview'
  ) {
    return userRole === 'resident'
      ? '/profile?tab=documents'
      : (data.residentId ? `/resident-profile/${data.residentId}` : '/users');
  }

  return null;
};

